<template>
    <div>
        <v-btn color="warning" @click="onImport()"> Import </v-btn>
        <v-radio-group dense v-model="selectedLang" @change="radioChange()" column class="mb-3" hide-details>
            <v-radio v-for="language in availableLanguages" v-bind:key="language" :label="language" :value="language"> </v-radio>
        </v-radio-group>
        <v-btn color="success" @click="onSave()"> Salva </v-btn>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    data() {
        return {
            selectedLang: "en",
        };
    },
    computed: {
        ...mapState({
            availableLanguages: (state) => state.application.availableLanguages,
        }),
    },

    methods: {
        onSave() {
            console.log("On save");
        },

        radioChange() {
            console.log("Lingua selezionata");
        },
    },
};
</script>
